<div *ngIf="isDevelopment">This is dev version 2.4.43</div>
<router-outlet></router-outlet>
